import apiClient, { getTokenFromLocalStorage } from '../utils/apiClient';

const getBaseUrl = () =>
  process.env.REACT_APP_PUBLIC_BASE_URL || 'http://localhost:8009/api';

/**
 * Order API services
 */
export const orderAPI = {
  getOrders: async (params = {}) => {
    return await apiClient.get({
      url: '/orders',
      params,
    });
  },

  /**
   * Xuất đơn hàng ra CSV (theo khoảng ngày và bộ lọc). Trả về Blob để tải file.
   */
  exportOrdersCsv: async (params = {}) => {
    const token = getTokenFromLocalStorage();
    const search = new URLSearchParams({ ...params, format: 'csv' }).toString();
    const res = await fetch(`${getBaseUrl()}/orders/export?${search}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.message || 'Xuất CSV thất bại');
    }
    return res.blob();
  },

  getOrderById: async (orderId) => {
    return await apiClient.get({
      url: `/orders/${orderId}`,
    });
  },

  /**
   * #232308 (lệnh sếp 02/09/2026, nút `sdt_nut_moi_hien`) — bấm nút "Xem số điện
   * thoại" của khách trên đơn. Máy chủ ghi 1 dòng nhật ký (ai xem số của khách nào,
   * đơn nào, lúc nào) rồi mới trả số đầy đủ.
   *
   * ADMIN/MANAGER cũng phải đi qua đúng nút này — sếp nói "không phải ai xem cũng
   * như ai", nên quyền cao KHÔNG được miễn để lại vết (AC13).
   */
  revealCustomerPhone: async (orderId) => {
    return await apiClient.post({
      url: `/orders/${orderId}/phone-view`,
    });
  },

  createOrder: async (payload) => {
    return await apiClient.post({
      url: '/orders',
      data: payload,
    });
},

  updateStatus: async (orderId, status) => {
    return await apiClient.put({
      url: `/orders/${orderId}/status`,
      data: { status },
    });
  },

  updatePayment: async (orderId, payload) => {
    return await apiClient.put({
      url: `/orders/${orderId}/payment`,
      data: payload,
    });
  },

  generateInvoice: async (orderId) => {
    return await apiClient.post({
      url: `/orders/${orderId}/invoice`,
    });
  },
};

